import { createI18n } from "vue-i18n";

import en from "@/locales/en.json";
import ja from "@/locales/ja.json";

export default {
  install: (app, options) => {
    const messages = {
      en: { greeting: "hi", ...en, ...options.en },
      ja: { greeting: "こんにちは", ...ja, ...options.ja },
    };
    console.log(messages);
    const i18n = createI18n({
      legacy: false,
      locale: "en",
      messages,
    });
    app.use(i18n);
  },
};
